import { FC } from 'react'
import styles from './TruemedBenefits.module.scss'
import { TruemedBenefitsProps, defaultBenefits } from './TruemedBenefits.types'
import { Button } from 'components/Phantom/Button/Button'
import { Img } from 'components/basic/Img'

const BenefitCard = (props: { title: string; content: string }) => (
	<div className={styles.benefit_card}>
		<div className={styles.card_header}>{props.title}</div>
		<div className={styles.card_content}>{props.content}</div>
	</div>
)

export const TruemedBenefits: FC<TruemedBenefitsProps> = (props) => {
	const {} = props
	return (
		<div className={styles.container}>
			<div className={styles.header}>
				<p className={styles.new_tag}>New</p>

				<div className={styles.headline}>
					Eight Sleep has partnered with
					<Img
						className={styles.truemed_big_logo}
						src={'https://d115sb6i1ixllw.cloudfront.net/assets/trueMed.svg'}
						alt={''}
					/>
				</div>
			</div>
			<div className={styles.benefits_wrapper}>
				{defaultBenefits.map((benefit) => (
					<BenefitCard
						key={benefit.title}
						title={benefit.title}
						content={benefit.content}
					/>
				))}
			</div>
			<div className={styles.cta}>
				<Button.Dark
					id={'truemed-lp'}
					href={'/product/pod-cover'}
				>
					Shop now
				</Button.Dark>
				<div className={styles.cta_footer}>
					HSA/FSA-eligible with{' '}
					<Img
						className={styles.truemed_big_small}
						src={'https://d115sb6i1ixllw.cloudfront.net/assets/trueMed.svg'}
						alt={''}
					/>
				</div>
			</div>
		</div>
	)
}
